import React, { useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';

import validator from 'validator';

import { Link as RouterLink } from 'react-router-dom';

import { NavContext, NavRoutes } from '../contexts/NavContext';

import {
    Breadcrumbs,
    Link,
    Typography
} from '@material-ui/core';

import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    }
}));

const LinkRouter = props => <Link {...props} component={RouterLink} />;

export const CrumbsBar = ({ ...props }) => {
    const classes = useStyles();

    const {
        allRoutes,
        navigateTo
    } = useContext(NavContext);

    const getNormalizedNavRoute = (navRoute) => {
        const routeTokens = navRoute.substring(1).split("/");
        let route = "";
        for (let index in routeTokens) {
            const token = routeTokens[index];
            if (token.startsWith(":")) {
                route += "/:prm";
            } else {
                route += `/${token}`;
            }
        }
        return route;
    }

    const isPathHidden = (path) => {
        switch (path) {
            case getNormalizedNavRoute(NavRoutes.Admin.Role):
            case getNormalizedNavRoute(NavRoutes.Admin.RoleUser):
            case getNormalizedNavRoute(NavRoutes.Admin.Table):
            case getNormalizedNavRoute(NavRoutes.Tables):
            case getNormalizedNavRoute(NavRoutes.TableContent):
            case getNormalizedNavRoute(NavRoutes.DownloadExport):
            case getNormalizedNavRoute(NavRoutes.Forbidden):
            case getNormalizedNavRoute(NavRoutes.NotFound):
                return true;
            default:
                return false;
        }
    }

    const isCustomToken = (prevTokens, token) => {
        if (prevTokens[0] === "exports" && prevTokens[1] === "download") {
            return true;
        } else {
            return false;
        }
    }

    const getPathTitle = (token, path) => {
        switch (path) {
            case getNormalizedNavRoute(NavRoutes.Admin.Role):
                return "Role";
            case getNormalizedNavRoute(NavRoutes.Admin.RoleUser):
                return "User";
            case getNormalizedNavRoute(NavRoutes.Admin.Table):
                return "Table";
            case getNormalizedNavRoute(NavRoutes.TableContent):
                return "Table";
            default:
                return token.charAt(0).toUpperCase() + token.slice(1);
        }
    }

    const location = useLocation();
    const [breadcrumbs, setBreadcrumbs] = useState([]);
    useEffect(() => {
        const pathTokens = location.pathname.substring(1).split("/");
        const breadcrumbs = [];
        const prevTokens = [];
        let url = "";
        let crumbPath = "";
        for (let index in pathTokens) {
            const token = pathTokens[index];
            url += `/${token}`;
            if (validator.isInt(token)) {
                crumbPath += "/:prm";
            } else if (validator.isUUID(token)) {
                crumbPath += "/:prm";
            } else if (isCustomToken(prevTokens, token)) {
                crumbPath += "/:prm";
            } else {
                crumbPath += `/${token}`;
            }

            prevTokens.push(token);
            breadcrumbs.push({ title: getPathTitle(token, crumbPath), url, hidden: isPathHidden(crumbPath), token });
        }
        setBreadcrumbs(breadcrumbs);
    }, [location]);

    return (
        <Breadcrumbs
            aria-label="breadcrumb"
            color="inherit"
            className={clsx(classes.root, props.className)}>
            { breadcrumbs && breadcrumbs.length > 0 && breadcrumbs.map((bc, index) => {
                if (index < breadcrumbs.length - 1) {
                    return bc.hidden ? "" : (
                        <LinkRouter key={index} color="inherit" to={bc.url}>
                            {bc.title}
                        </LinkRouter>
                    )
                } else {
                    return bc.hidden ? "" : <Typography key={index} color="inherit">{bc.title}</Typography>;
                }
            })}
        </Breadcrumbs >
    );
}